import React from "react";
import Comment from "./Comment";

export interface RecursiveCommentProps {
    comment: any;
    contentInputRef?: React.RefObject<HTMLInputElement | HTMLTextAreaElement>;
    handleReply: (id: number) => void;
}

const RecursiveComment: React.FC<RecursiveCommentProps> = ({
    comment,
    contentInputRef,
    handleReply,
}) => {
    return (
        <div className="mt-5">
            <Comment
                response={comment}
                isSmall={!!comment?.parent_id}
                contentInputRef={contentInputRef}
                onReply={() => handleReply(comment?.id)}
            />
            {comment?.replies?.length > 0 && (
                <ul className="pl-4 mt-5 space-y-5 md:pl-11">
                    {comment.replies.map((reply: any) => (
                        <li key={reply.id}>
                            <RecursiveComment
                                comment={reply}
                                contentInputRef={contentInputRef}
                                handleReply={handleReply}
                            />
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default RecursiveComment;
